<section class="centered-with-padding py-7">
  <div class="grid grid-cols-1 justify-between gap-y-[50px] desk:grid-cols-2">
    @for (produit of data.produits; track $index) {
      <div
        [ngClass]="{
          'desk:grid-cols-[1fr_1fr_2fr]': produit.lifestyleImage,
          'desk:grid-cols-[2fr_1fr_1fr]': produit.lifestyleImage && produit.isImageFirst,
          'desk:col-span-2': produit.lifestyleImage,
        }"
        class="grid grid-cols-1">
        <div [ngClass]="{ 'desk:col-span-2': produit.lifestyleImage }" class="grid grid-cols-2 gap-x-2 gap-y-[14px]">
          <div class="h-[170px] desk:h-60">
            <app-image [image]="produit.productImage" [isPriority]="!isImageInPreviousBlocks && $index < 2" />
          </div>
          <div class="flex flex-col gap-5">
            <div>
              <app-title [title]="{ text: produit.name, as: 'span' }" size="custom-30-35" />
            </div>
            <div>
              <div>{{ "COMPONENT.LISTING-COIN-REPAS.FROM" | translate }}</div>
              <div class="font-title text-[33px] leading-[38px] desk:text-[40px] desk:leading-[35px]">
                {{ produit.price }}
              </div>
              <div>{{ "COMPONENT.LISTING-COIN-REPAS.PER_UNIT" | translate }}</div>
              @if (produit.ecoPart) {
                <div class="text-sm leading-[10px]">
                  {{ "GLOBAL.INCLUDING_X_ENVIRONMENTAL_TAX" | translate: { environmentalTaxPrice: produit.ecoPart } }}
                </div>
              }
            </div>
          </div>
          <div [innerHTML]="produit.description"></div>
          <div
            [innerHTML]="produit.details"
            class="prose prose-custom-marker -mt-3 leading-tight prose-li:my-1.5"></div>
        </div>
        @if (produit.lifestyleImage) {
          <div
            [ngClass]="{
              'desk:col-span-1': produit.lifestyleImage,
              'desk:order-[-1]': produit.isImageFirst,
              'desk:grid-cols-[4fr_1fr]': produit.isImageFirst,
            }"
            class="col-span-2 h-64 desk:grid desk:grid-cols-[1fr_4fr]">
            <div class="size-full desk:col-span-2 desk:h-[350px]">
              <div class="h-full overflow-hidden rounded-[30px] desk:w-5/6">
                <app-image [image]="produit.lifestyleImage" [isPriority]="!isImageInPreviousBlocks && $index < 2" />
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>
